"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Overlap = function Overlap(props) {
  var children = props.children,
    zIndex = props.zIndex,
    open = props.open;
  var root = (0, _useCss["default"])(function (theme) {
    return {
      zIndex: zIndex,
      position: 'fixed',
      width: '100dvw',
      height: '100dvh',
      top: 0,
      left: 0,
      backgroundColor: theme.palette.background.primary.color,
      visibility: open ? 'visible' : 'hidden',
      opacity: open ? 1 : 0,
      transitionDuration: '200ms'
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: root,
    children: children
  });
};
var _default = Overlap;
exports["default"] = _default;